const getters = {
  module: state => state.user.module
}
export default getters
